import React from 'react'
import { ListWrapper, Wrapper } from './style'
import bannerImg from "../../assets/images/homebanner.png";
import DemoButtons from '../../Pages/AboutSdk/DemoButtons';

function SdkBanner() {
  return (
   <div className='container' style={{maxWidth:"1480px"}}>
     <Wrapper  className='banner' >
       <div className="flex items-center">
        <div className="left">
        <h2 class="heading-2 mb20 text-center"><span class="strong fs-sm-20">Build Travel Apps Faster, Smarter, and Better.</span></h2>
        
            <p className='fs-sm-12'>We provide a robust Travel Services SDK designed to empower developers and businesses with ready-to-integrate travel features</p>
            <div>
              <ListWrapper  >
                 <li>No API integration hassles </li>
                 <li>No backend chaos </li>
              </ListWrapper>
            </div>
            <DemoButtons />
        </div>
        <div className="right">
          <img src={bannerImg} alt="bannerImg" />
        </div>
       </div>
   </Wrapper>
   </div>
  )
}

export default SdkBanner;